var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar',{attrs:{"data":_vm.data,"logo-url":_vm.urlGenerator('/'),"logo-src":_vm.resolvedLogoSrc,"logo-icon-src":_vm.resolvedLogoIconSrc,"company-name":_vm.configData.company_name}})
}
var staticRenderFns = []

export { render, staticRenderFns }